<template>
    <div>
        <div id="uploadSheetModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Upload Excel Workbook
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <file-pond
                            name="file"
                            ref="pond"
                            :server="server"
                            :onprocessfile="handleOnProcessFile"
                            allowRevert="false"
                            allowMultiple="false"
                            allowRemove="false"
                            class-name="my-pond"
                            dropOnElement="true"
                            dropOnPage="true"
                            label-idle="Drop or select a xlsx workbook"
                            accepted-file-types="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet"
                            labelFileTypeNotAllowed="Invalid File Type"
                            fileValidateTypeLabelExpectedTypes="Only XLSX Workbooks Are Allowed."/>
                    </div>
                </div>
            </div>
        </div>
        <div id="proposal-settings-template-manage-div" class="p-3">
            <div class="row">
                <div class="col-md-6 float-left mb-3">
                    <h5 class="mt-1 float-left mr-3">{{ selectedProposalContentSheet.template_name }}</h5>
                </div>
                <div class="col-md-6 float-right text-right pt-1">
                    <div class="pr-0">
                        <div class="col-md-4 p-0 m-0 float-left pt-2 pr-3">
                            {{savingPrizmSheet}}
                        </div>
                        <div class="col-md-5 p-0 m-0 float-left text-left">
                            <button type="button" @click="openUploadSheetModal()" class="bg-followup-nav hover:bg-followup-nav-darker px-2 py-1 text-white focus:outline-none rounded add-new-template-button">
                                <i class="fa fa-cloud-upload" aria-hidden="true"></i> Upload Excel Workbook
                            </button>
                        </div>
                        <div class="col-md-3 p-0 m-0 float-left text-left">
                            <button id="add-proposal-template" name="add-proposal-template" @click="prizmSheetSave()"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 text-white focus:outline-none rounded add-new-template-button">
                                Save Content
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100">
                <div id="workbook-control-container" style="width:100%;height:150vh"></div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import Swal from "sweetalert2";

export default {
    name: "proposal-settings-content-sheet-manage",
    props:['proposalContentSheet'],
    components: {},
    data() {
        return {
            selectedProposalContentSheet: (this.proposalContentSheet)? this.proposalContentSheet:null,
            sheetId: null,
            sheetURL: (this.proposalContentSheet.sheet_url)? this.proposalContentSheet.sheet_url:null,
            prizmEditorBaseURL: null,
            savingPrizmSheet: 'Saved',
            workbookControl: null,
            server: {
                process: (fieldName, file, metadata, load, error, progress) => {
                    let self = this;
                    const formData = new FormData();
                    formData.append('file', file, file.name);
                    formData.append('content', self.selectedProposalContentSheet.id);
                    const request = new XMLHttpRequest();
                    request.open('POST', route('api.proposal-content.sheet.upload-custom-sheet'));
                    let token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                    request.setRequestHeader('X-CSRF-TOKEN', token);
                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                            let response = JSON.parse(request.response);
                            // self.sheetId = response.sheet_id;
                            self.documentURL = response.documentURL;
                            self.sheetEditor.destroyEditor();
                            self.loadOnlyOfficeEditor();
                        } else {
                            error('Please try again.');
                        }
                    };
                    request.send(formData);
                }
            },
            sheetEditor: null,
            editorConnectors: null,
            docState: null,
            documentURL: null,
            documentKey: null,
        }
    },
    mounted(){
        this.prizmSheetBaseURL = process.env.MIX_PRIZM_SHEET_URL;
        // this.getSheetIdFromDB();
        this.getDocument();
    },
    methods: {
        getSheetIdFromDB(){
            let self = this;
            axios.post(route('api.proposal-content.sheet.get-sheet-id'),{content:self.selectedProposalContentSheet})
                .then((response) => {
                    if(response.data.sheetId !== null) {
                        self.sheetId = response.data.sheetId;
                        self.createPrizmSheetSession();
                    }else{
                        self.sheetURL = response.data.sheetURL;
                        self.uploadCustomSheet();
                    }
                });
        },
        createPrizmSheetSession(){
            let self = this;
            this.$nextTick(()=>{
                axios.post(route('prizm.create-sheet-session'),{sheetId:self.sheetId})
                    .then((response) => {
                        self.sessionId = response.data.response.sessionId;
                        self.createPrizmSheet();
                    });
            });
        },
        async createPrizmSheet(){
            $('#workbook-control-container').empty();
            let self = this;
            const workbook = await Accusoft.WorkbookControl.create({
                baseUrl: self.prizmSheetBaseURL,
                sessionId: self.sessionId,
                container: document.getElementById('workbook-control-container')
            });
            self.workbookControl = workbook;
            workbook.on('selectionChanged', () => {
                workbook.forceSave();
            });

        },
        prizmSheetSave(){
            this.savingPrizmSheet = 'Saving...';
            this.saveOnlyOfficeDocument('button');
            // this.saveSheetURLInSection();
        },
        saveSheetURLInSection(){
            let self = this;
            this.$nextTick(()=>{
                axios.post(route('api.proposal-content.sheet.update-sheet-id'),{content:self.selectedProposalContentSheet,sheetId:self.sheetId})
                    .then((response) => {

                    });
            });
        },
        uploadPrizmSheetWorkBook(){
            let self = this;
            axios.post(route('prizm.upload-sheet'))
                .then((response) => {

                });
        },
        uploadCustomSheet(){
          axios.post(route('api.proposal-content.sheet.upload-custom-sheet'), {sheetURL: this.sheetURL, file:null, content:this.selectedProposalContentSheet.id})
              .then((response) => {
                  this.sheetId = response.data.sheet_id;
                  this.createPrizmSheetSession();
          });
        },
        openUploadSheetModal(){
            $('#uploadSheetModal').modal("show");
        },
        handleOnProcessFile(){
            $('#uploadSheetModal').modal("hide");
            $('#workbook-control-container').empty();
            this.sheetEditor.destroyEditor();
            this.loadOnlyOfficeEditor();
        },
        loadOnlyOfficeEditor(){
            let self = this;
            let documentKey = self.makeid(10);
            let baseURL = window.location.origin;
            self.documentKey = documentKey;
            const config = {
                document: {
                    fileType: "xlsx",
                    key: documentKey,
                    title: "Title.xlsx",
                    url: self.documentURL,
                },
                documentType: "cell",
                editorConfig: {
                    mode: "edit",
                    callbackUrl: baseURL+"/only-office-callback-for-content/"+this.proposalContentSheet.id+'/sheet',
                    coEditing: {
                        mode: 'fast',
                        change: true
                    },
                    customization: {
                        uiTheme: 'theme-followup',
                        customer: {
                            name: 'FollowupCRM',
                            logo: 'https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png'
                        },
                        forcesave: true,
                        logo: {
                            image: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            imageDark: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            url: "https://app.followupcrm.com/"
                        },
                        plugins: true,
                        unit: 'inch',
                        anonymous: {
                            request: true,
                            label: "Guest"
                        },
                        hideRightMenu: true
                    },
                },
                height: "900px",
                type: "desktop",
                width: "100%",
                customization: {
                    anonymous: {
                        request: true,
                        label: "Guest"
                    },
                    autosave: true
                },
                events: {
                    'onDocumentReady': function(){
                        self.editorConnectors = self.sheetEditor.createConnector();
                    },
                    'onDocumentStateChange': function(){
                        self.saveOnlyOfficeDocument(null);
                    }
                },
                permission: {
                    edit: true,
                    protect: false,
                    review: false
                }
            };

            self.sheetEditor = new DocsAPI.DocEditor("workbook-control-container", config);
            self.$nextTick(() => {
                this.setEventsForOnlyOffice();
            });
        },
        setEventsForOnlyOffice(){
            this.editorConnectors = this.sheetEditor.createConnector();
        },
        makeid(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        },
        getDocument(){
            axios.post(route('proposal.only-office.get-sheet-for-content'),{contentId:this.proposalContentSheet.id}).then((response) => {
                this.documentURL = response.data.documentURL;
                this.$nextTick(() => {
                    this.loadOnlyOfficeEditor();
                });
            });
        },
        saveOnlyOfficeDocument(fromWhere){
            this.savingPrizmSheet = 'Saving...';
            axios.post(route('proposal.only-office.save-document'), {documentKey: this.documentKey, formFieldCount: 0, typeId: null, type: 'contentSheet'})
                .then((response) => {
                    if(fromWhere){
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }
                    this.savingPrizmSheet = 'Saved';
                });
        },
    }
};
</script>

<style>
#proposal-settings-template-manage-div {
    padding: 5px 0;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
    background-color:#fff;
    min-height: 80vh;
    border-radius:5px;
}
#proposal-settings-template-manage-div h5{
    color: #222;
    font-weight: 400;
    padding: 5px 0px;
}
#proposal-settings-template-manage-div .add-new-template-button{
    height: 40px;
    font-weight: 300;
}
</style>
